import { PlanSocialNetwork } from '../models/mobile-plan-promo.model';

export const PLAN_PROMO_DEFAULT_CTA = 'Más Información';

/** Redes por tier de precio (diseño fijo; no provienen del API). */
const SOCIAL_NETWORKS_BY_PRICE: Readonly<Record<number, readonly PlanSocialNetwork[]>> = {
  100: ['facebook', 'x', 'whatsapp', 'telegram', 'messenger'],
  200: [
    'facebook',
    'x',
    'instagram',
    'whatsapp',
    'snapchat',
    'telegram',
    'messenger'
  ],
  300: [
    'facebook',
    'x',
    'instagram',
    'whatsapp',
    'snapchat',
    'telegram',
    'messenger'
  ]
};

const SOCIAL_NETWORKS_BY_INDEX: readonly (readonly PlanSocialNetwork[])[] = [
  SOCIAL_NETWORKS_BY_PRICE[100],
  SOCIAL_NETWORKS_BY_PRICE[200],
  SOCIAL_NETWORKS_BY_PRICE[300]
];

export function getPlanPromoSocialNetworks(
  monthlyPrice: number,
  index: number
): readonly PlanSocialNetwork[] {
  const tier = SOCIAL_NETWORKS_BY_PRICE[monthlyPrice];
  if (tier) {
    return tier;
  }
  const fallback = SOCIAL_NETWORKS_BY_INDEX[index];
  return fallback?.length ? fallback : SOCIAL_NETWORKS_BY_INDEX[0];
}
